import React from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { projects } from "../theme/projectBranding";
import { useThemeSwitcher } from "../theme/ThemeContext";

const ThemePalette = ({ open, onClose }) => {
  const { themeName, setThemeName } = useThemeSwitcher();

  const handleSelect = (name) => {
    setThemeName(name);
  };

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 320,
          bgcolor: "background.default",
          borderRight: "1px solid",
          borderColor: "divider",
        },
      }}
    >
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: "-0.02em" }}>
            Themes
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {Object.entries(projects).map(([key, project]) => {
            const isActive = key === themeName;
            const pal = project.palette;
            return (
              <Box
                key={key}
                onClick={() => handleSelect(key)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1.5,
                  borderRadius: 2,
                  cursor: "pointer",
                  border: "2px solid",
                  borderColor: isActive ? pal.primary.main : "transparent",
                  bgcolor: isActive ? "action.selected" : "background.paper",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    bgcolor: "action.hover",
                    borderColor: pal.primary.main,
                  },
                }}
              >
                {/* Color swatches */}
                <Box sx={{ display: "flex", gap: 0.5, flexShrink: 0 }}>
                  <Box sx={{
                    width: 24, height: 24, borderRadius: "50%",
                    bgcolor: pal.primary.main,
                    border: "2px solid",
                    borderColor: "rgba(255,255,255,0.1)",
                  }} />
                  <Box sx={{
                    width: 24, height: 24, borderRadius: "50%",
                    bgcolor: pal.secondary.main,
                    border: "2px solid",
                    borderColor: "rgba(255,255,255,0.1)",
                  }} />
                  <Box sx={{
                    width: 24, height: 24, borderRadius: "50%",
                    bgcolor: pal.background.paper,
                    border: "2px solid",
                    borderColor: "rgba(255,255,255,0.15)",
                  }} />
                </Box>

                <Typography
                  variant="body2"
                  sx={{ fontWeight: isActive ? 700 : 500, flexGrow: 1 }}
                >
                  {project.name}
                </Typography>

                {isActive && (
                  <CheckCircleIcon
                    sx={{ fontSize: 20, color: pal.primary.main }}
                  />
                )}
              </Box>
            );
          })}
        </Box>
      </Box>
    </Drawer>
  );
};

export default ThemePalette;
